module.exports = __webpack_public_path__ + "img/dadata-logo.7b1d9d8a.svg";